import { useEffect, useState } from "react";

export default function CustomerDetails({ phone, apiFetch }) {
  const [result, setResult] = useState({ phone: null, details: null, error: "" });
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    let cancelled = false;
    setResult({ phone, details: null, error: "" });
    apiFetch(`/contacts/${encodeURIComponent(phone)}/details${refresh ? "?refresh=true" : ""}`, { signal: controller.signal }).then(data => {
      if (cancelled) return;
      if (!data.details) throw new Error(data.error || "Unable to load customer details.");
      setResult({ phone, details: data.details, error: "" });
    }).catch(error => {
      if (!cancelled) setResult({ phone, details: null, error: error.message || "Unable to load customer details." });
    });
    return () => { cancelled = true; controller.abort(); };
  }, [phone, apiFetch, refresh]);
  const current = result.phone === phone ? result : { details: null, error: "" };
  const details = current.details;
  const loading = !details && !current.error;
  return (
    <aside className="customer-details" aria-label="Customer details">
      <details open>
        <summary>Customer details</summary>
        {loading && <p className="customer-details-status" role="status">Loading customer details…</p>}
        {current.error && <p className="star-error" role="alert">{current.error}</p>}
        <table className="customer-details-table">
          <caption>Details for +{phone}</caption>
          <tbody>
            <tr><th scope="row">Customer category</th><td>{loading ? "…" : details?.category || (current.error ? "Unavailable" : "Not set")}
              {details?.categorySource && <small>Campaign: {details.categorySource}</small>}
            </td></tr>
            <tr><th scope="row">HubSpot contact ID</th><td>{loading ? "…" : details?.hubspotContactId || (details?.linkStatus === "multiple_matches" ? "Multiple contacts found" : current.error ? "Unavailable" : "Not linked")}</td></tr>
            <tr><th scope="row">HubSpot contact link</th><td>{details?.hubspotContactUrl
              ? <a href={details.hubspotContactUrl} target="_blank" rel="noopener noreferrer">Open contact in HubSpot ↗</a>
              : loading ? "…" : "—"}</td></tr>
          </tbody>
        </table>
        <button className="btn-sm" disabled={loading} onClick={() => setRefresh(n => n + 1)}>{current.error ? "Retry" : "Refresh details"}</button>
      </details>
    </aside>
  );
}
